import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import {
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { labelFormatterNumber } from '../../../../../../../shared/formatters/formatters';
import { AbsorptionAndLiquidityData } from '../../../../redux/studies.model';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ImgUrls, usePDFData } from '../../../pdfReports/usePDFData';
import { BlobProvider } from '@react-pdf/renderer';
import { ViabilityReport } from '../../../pdfReports/viabilityReport';
import { uploadPDFReport } from '../../../../redux/studies.controller';
import { setIsLoadingMap } from '../../../../../redux/dashboardActions';
import { AddAlert } from '../../../../../../../component';
import { downloadBlob } from '../../../../../../../shared/utils/exporter';

const dictionary = nls.studyCreationGuide.steps.step7;

export const AbsorptionAndLiquidityResponse: React.FC = () => {
  const {
    absorptionAndLiquidityResponsePrimary,
    absorptionAndLiquidityResponseSecondary,
  } = useTypedSelector(studiesSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentProgressTo(7));
  }, []);
  const {
    layoutsValuationPayload,
    layoutsValuationPrimaryResponse,
    layoutsValuationSecondaryResponse,
    installmentsSimulationPrimary,
    installmentsSimulationSecondary,
    studyName,
    creationDate,
    id,
    polygon,
    expandedArea,
    author,
  } = useTypedSelector(studiesSelector);
  const { imgURLs, layoutsFormattedData } = usePDFData({
    polygon,
    expandedArea,
    layoutCharacteristics: layoutsValuationPayload ?? null,
    layoutValuationResponsePrimary: layoutsValuationPrimaryResponse,
    layoutValuationResponseSecondary: layoutsValuationSecondaryResponse,
    absorptionAndLiquidity: absorptionAndLiquidityResponsePrimary,
    installmentsSimulationPrimary: installmentsSimulationPrimary,
    installmentsSimulationSecondary: installmentsSimulationSecondary,
  });
  const headerInfo = {
    studyName,
    creationDate,
    id,
  };
  const hasResponseSecondary =
    absorptionAndLiquidityResponseSecondary &&
    absorptionAndLiquidityResponseSecondary.length > 0;
  const mapImages: ImgUrls = [imgURLs.polygon, imgURLs.expandedArea];

  const handleClickObtainReport = async (blob: Blob | null) => {
    try {
      if (blob) {
        dispatch(setIsLoadingMap(true));
        await uploadPDFReport(id, blob, author, studyName);
        downloadBlob(blob, `${studyName}.pdf`);
      }
    } catch (e) {
      dispatch(AddAlert('warning', 'Erro ao fazer upload do relatório'));
    } finally {
      dispatch(setIsLoadingMap(false));
    }
  };
  return (
    <>
      <p style={{ fontWeight: 700, marginTop: 16, fontSize: 14 }}>
        {dictionary.accordingToPrimaryMarket}
      </p>
      {absorptionAndLiquidityResponsePrimary?.map((layoutData, index) => (
        <DisplayData
          layoutData={layoutData}
          layoutKey={layoutData.id}
          key={index}
        />
      ))}
      {hasResponseSecondary && (
        <p style={{ fontWeight: 700, marginTop: 16, fontSize: 14 }}>
          {dictionary.accordingToSecondaryMarket}
        </p>
      )}
      {hasResponseSecondary &&
        absorptionAndLiquidityResponseSecondary.map((layoutData, index) => (
          <DisplayData
            layoutData={layoutData}
            layoutKey={layoutData.id}
            key={index}
          />
        ))}
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          {layoutsFormattedData && (
            <BlobProvider
              document={
                <ViabilityReport
                  imageSources={mapImages}
                  layoutsFormattedData={layoutsFormattedData}
                  headerInfo={headerInfo}
                />
              }
            >
              {({ blob, url, loading, error }) => {
                return (
                  <button
                    onClick={() => handleClickObtainReport(blob)}
                    className="btn primary normal"
                  >
                    {nls.studyCreationGuide.buttons.obtainReport}
                  </button>
                );
              }}
            </BlobProvider>
          )}
          {/* {layoutsFormattedData && (
            <PDFDownloadLink
              document={
                <ViabilityReport
                  imageSources={mapImages}
                  layoutsFormattedData={layoutsFormattedData}
                  headerInfo={headerInfo}
                />
              }
              fileName={studyName}
              className="pdf-download-button"
            >
              {nls.studyCreationGuide.buttons.obtainReport}
            </PDFDownloadLink>
          )} */}
        </div>
      </div>
    </>
  );
};

interface DisplayDataProps {
  layoutData: AbsorptionAndLiquidityData;
  layoutKey: string;
}

const DisplayData: React.FC<DisplayDataProps> = ({ layoutData, layoutKey }) => {
  return (
    <div className="absorption-and-liquidity">
      <div className="row-container-space-between">
        <h6 className="layout-number">
          {dictionary.layoutNumber} {layoutKey}
        </h6>
        <p>{layoutData.area}m²</p>
      </div>
      <div className="row-container-space-between">
        <p>{dictionary.absorption}</p>
        <p>{layoutData.absorption}</p>
      </div>
      <div className="row-container-space-between">
        <p>{dictionary.qualifiedAudience}</p>
        <p>{labelFormatterNumber(layoutData.qualifiedAudience)}</p>
      </div>
      <div className="row-container-space-between">
        <p>{dictionary.liquidity}</p>
        <p>{layoutData.liquidity}</p>
      </div>
      <div className="row-container-space-between">
        <p>{dictionary.conversionRate}</p>
        <p>{layoutData.conversionRate}</p>
      </div>
      <div
        className={`row-container-space-between ${
          layoutData.phasingEstimate > 3 ? 'bad' : 'good'
        }`}
      >
        <p>{dictionary.phasingEstimate}</p>
        <p>{layoutData.phasingEstimate}x</p>
      </div>
    </div>
  );
};
